import React from 'react';
import { BooleanColumn, NumericalColumn, CategoricalColumn, CustomColumn } from 'baseui/data-table';
import { EMPTY_OBJECT } from 'commons-ui';
import { ShowReferralDetails, getReferralPolicyDetailsModal } from '../../../utils/ReferralDetailsColumn';

export const COL_NAMES = {
	segment: 'segmentName',
	isActive: 'isActive',
	isReferralActive: 'isReferralActive',
	referralCapping: 'referralCapping',
	allowedReferralFlows: 'allowedReferralFlows',
	deposit: 'deposit',
	gamePlay: 'gamePlay',
	signUp: 'signUp',
	kyc: 'kyc',
	delayRewardInSeconds: 'delayRewardInSeconds',
	isLatest: 'isLatest'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Segment',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.segment]
	}),
	BooleanColumn({
		title: 'isActive',
		maxWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.isActive]
	}),
	BooleanColumn({
		title: 'isReferralActive',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isReferralActive]
	}),
	NumericalColumn({
		title: 'Referral Capping',
		mapDataToValue: (data: any) => (data[COL_NAMES.referralCapping] ? data[COL_NAMES.referralCapping] : ''),
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Allowed Referral Flows',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data.policy[COL_NAMES.allowedReferralFlows] ? JSON.stringify(data.policy[COL_NAMES.allowedReferralFlows]) : ''
	}),
	NumericalColumn({
		title: 'Delay In Reward ( In Sec )',
		mapDataToValue: (data: any) =>
			data.policy[COL_NAMES.delayRewardInSeconds] ? data.policy[COL_NAMES.delayRewardInSeconds] : '',
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'Is Latest',
		maxWidth: 200,
		mapDataToValue: (data: any) => data.policy[COL_NAMES.isLatest]
	}),
	CustomColumn({
		title: 'Deposit',
		maxWidth: 200,
		mapDataToValue: (data: any) => (data.policy[COL_NAMES.deposit] ? data.policy[COL_NAMES.deposit] : EMPTY_OBJECT),
		renderCell: (params: any) => {
			const referralDetailParams = {
				...params,
				header: 'Deposit Benefit',
				content: getReferralPolicyDetailsModal(params.value)
			};
			return <ShowReferralDetails {...referralDetailParams} />;
		}
	}),
	CustomColumn({
		title: 'Game Play',
		maxWidth: 200,
		mapDataToValue: (data: any) => (data.policy[COL_NAMES.gamePlay] ? data.policy[COL_NAMES.gamePlay] : EMPTY_OBJECT),
		renderCell: (params: any) => {
			const referralDetailParams = {
				...params,
				header: 'Game Play Benefit',
				content: getReferralPolicyDetailsModal(params.value)
			};
			return <ShowReferralDetails {...referralDetailParams} />;
		}
	}),
	CustomColumn({
		title: 'Sign Up',
		maxWidth: 200,
		mapDataToValue: (data: any) => (data.policy[COL_NAMES.signUp] ? data.policy[COL_NAMES.signUp] : EMPTY_OBJECT),
		renderCell: (params: any) => {
			const referralDetailParams = {
				...params,
				header: 'Sign Up Benefit',
				content: getReferralPolicyDetailsModal(params.value)
			};
			return <ShowReferralDetails {...referralDetailParams} />;
		}
	}),
	CustomColumn({
		title: 'KYC',
		maxWidth: 200,
		fillWidth: true,
		mapDataToValue: (data: any) => (data.policy[COL_NAMES.kyc] ? data.policy[COL_NAMES.kyc] : EMPTY_OBJECT),
		renderCell: (params: any) => {
			const referralDetailParams = {
				...params,
				header: 'KYC Benefit',
				content: getReferralPolicyDetailsModal(params.value)
			};
			return <ShowReferralDetails {...referralDetailParams} />;
		}
	})
];

export const PAGE_DETAILS = {
	pageDetails: {
		pageNo: 1,
		pageSize: 10
	}
};
